import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { baseURL } from '../../../../constants/applicationConstants.js';
import { Loader } from '../../../common/loader/loader.jsx';
import CustomerAskTheExpertJsx from './roleManage.jsx'

export default class AskTheExpert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryData: null,
            isLoading: false,
            checkedItems: [],
            roleName: '', // Added state for role name
        }
    }

    // Handle change for checkboxes
    handleChange = (data) => {
        const { modulePermissionId, moduleId, checked } = data;
        
        // Update the categoryData to reflect the checkbox state
        const updatedCategoryData = this.state.categoryData.map(module => {
            if (module.moduleId === moduleId) {
                return {
                    ...module,
                    modulePermissions: module.modulePermissions.map(permission => {
                        if (permission.modulePermissionId === modulePermissionId) {
                            return {
                                ...permission,
                                hasPermission: checked
                            };
                        }
                        return permission;
                    })
                };
            }
            return module;
        });

        // Update checkedItems array
        let updatedCheckedItems;
        if (checked) {
            // Add to checkedItems if not already present
            const exists = this.state.checkedItems.some(item => 
                item.modulePermissionId === modulePermissionId && item.moduleId === moduleId
            );
            if (!exists) {
                updatedCheckedItems = [
                    ...this.state.checkedItems,
                    { modulePermissionId, moduleId }
                ];
            } else {
                updatedCheckedItems = this.state.checkedItems;
            }
        } else {
            // Remove from checkedItems
            updatedCheckedItems = this.state.checkedItems.filter(item => 
                !(item.modulePermissionId === modulePermissionId && item.moduleId === moduleId)
            );
        }

        this.setState({
            categoryData: updatedCategoryData,
            checkedItems: updatedCheckedItems
        });
    };

    // Handle role name input change
    handleRoleNameChange = (event) => {
        this.setState({ roleName: event.target.value });
    };

    // Get checked IDs and create role
    getCheckedIds = () => {
        // Validation: Check if role name is provided
        if (!this.state.roleName.trim()) {
            toast.error('Please enter a role name');
            return;
        }

        // Validation: Check if at least one permission is selected
        if (this.state.checkedItems.length === 0) {
            toast.error('Please select at least one permission');
            return;
        }

        let token = JSON.parse(localStorage.getItem('token'));

        const data = {
            "roleName": this.state.roleName.trim(),
            "access": "write",
            "modules": this.state.checkedItems
        }
        
        this.setState({ isLoading: true })

        axios.post(`${baseURL}/role`, data, {
            headers: {
                'x-access-token': token
            }
        }).then(res => {
            this.setState({ isLoading: false });
            toast.success('Role created successfully!');
            // Reset form after successful creation
            this.setState({
                roleName: '',
                checkedItems: [],
                categoryData: this.state.categoryData.map(module => ({
                    ...module,
                    modulePermissions: module.modulePermissions.map(permission => ({
                        ...permission,
                        hasPermission: false
                    }))
                }))
            });
        }).catch(err => {
            this.setState({ isLoading: false })
            toast.error(err.response?.data?.error?.message || 'Failed to create role')
        })
    };

    componentDidMount = () => {
        this.setState({ isLoading: true })
        let token = JSON.parse(localStorage.getItem('token'));
        
        axios.get(`${baseURL}/modules`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            const categoryData = res.data.data;
            
            // Initialize checkedItems with permissions that have hasPermission: true
            const initialCheckedItems = [];
            categoryData.forEach(module => {
                module.modulePermissions.forEach(permission => {
                    if (permission.hasPermission) {
                        initialCheckedItems.push({
                            modulePermissionId: permission.modulePermissionId,
                            moduleId: module.moduleId
                        });
                    }
                });
            });

            this.setState({ 
                categoryData: categoryData, 
                checkedItems: initialCheckedItems,
                isLoading: false 
            });
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error('Failed to load modules');
        });
    }

    render() {
        return (
            <div>
                <CustomerAskTheExpertJsx
                    categoryData={this.state.categoryData}
                    getCheckedIds={this.getCheckedIds}
                    handleChange={this.handleChange}
                    roleName={this.state.roleName}
                    handleRoleNameChange={this.handleRoleNameChange}
                />
                {this.state.isLoading && <Loader />}
                <ToastContainer />
            </div>
        )
    }
}